module.exports = __webpack_public_path__ + "static/img/kjdy14.ca8c0a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/kjdy14.png
// module id = 136
// module chunks = 0